import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';
import { EPOCH_COMMUNICATION_NOTIFICATION } from '@event-editor/tabs/EditEventCommunications/types/communication.types';

const GetEventCommunicationQuery = gql`
  query GetEventCommunication($eventId: Int!) {
    eventCommunicationNotifications(eventId: $eventId) {
      notifications {
        id
        title
        message
        mediums
        type
        targetStatuses
        status
        sendAt
      }
    }
  }
`;

export const getEventCommunication = {
  get: ({
    eventId
  }: {
    eventId: number;
  }): Promise<{ notifications: EPOCH_COMMUNICATION_NOTIFICATION[] }> => {
    return gqlClient
      .request<{
        eventCommunicationNotifications: { notifications: EPOCH_COMMUNICATION_NOTIFICATION[] };
      }>(GetEventCommunicationQuery, { eventId })
      .then((res) => res.eventCommunicationNotifications);
  }
};
